import * as tslib_1 from "tslib";
import setSafeMailingListsOption from '../actions/setSafeMailingListsOption';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { EditSendersAndDomains, isEmailAddress, } from 'owa-mail-option-common';
import { OptionDescription } from 'owa-options-controls';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var SafeMailingListsFull = /** @class */ (function (_super) {
    tslib_1.__extends(SafeMailingListsFull, _super);
    function SafeMailingListsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeMailingListsFull.prototype.render = function () {
        var mailingLists = getFallbackValueIfNull(this.props.optionState.safeMailingLists, this.props.junkEmailConfiguration.TrustedRecipientsAndDomains.filter(function (item) {
            return isEmailAddress(item);
        }));
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_junkEmail_safeMailingLists),
            React.createElement(EditSendersAndDomains, { items: mailingLists, onItemsChanged: function (safeMailingLists) { return setSafeMailingListsOption(safeMailingLists); }, mode: 0 /* EmailAddressOnly */ })));
    };
    SafeMailingListsFull = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
            junkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
        })
    ], SafeMailingListsFull);
    return SafeMailingListsFull;
}(React.Component));
export default SafeMailingListsFull;
//# sourceMappingURL=SafeMailingListsFull.js.map